module.exports = __webpack_public_path__ + "img/service_bg_full.aaf74f35.webp";